// ScrollContext.tsx
import { createContext, useContext, useRef } from 'react'

const ScrollContext = createContext<React.RefObject<HTMLDivElement> | null>(
  null,
)

export const ScrollProvider: React.FC<{ children: React.ReactNode }> = ({
  // eslint-disable-next-line react/prop-types
  children,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  return (
    <ScrollContext.Provider value={scrollRef}>
      {children}
    </ScrollContext.Provider>
  )
}

export const useScrollContext = () => {
  return useContext(ScrollContext)
}
